import axios from '@/axios'

export default {
  remove(id) {
    return new Promise((resolve, reject) => {
      axios
        .delete(`/dependants/${id}`)
        .then(response => {
          return resolve(response.data)
        })
        .catch(error => {
          return reject(error.data)
        })
    })
  },
  getOne(id) {
    return new Promise((resolve, reject) => {
      axios
        .get(`/dependants/${id}`)
        .then(response => {
          return resolve(response.data)
        })
        .catch(error => {
          return reject(error.data)
        })
    })
  },
  save(dependant) {
    return new Promise((resolve, reject) => {
      if (!dependant._id) {
        axios
          .post(`/dependants`, dependant)
          .then(response => {
            return resolve(response.data)
          })
          .catch(error => {
            return reject(error.data)
          })
      } else {
        axios
          .put(`/dependants/${dependant._id}`, dependant)
          .then(response => {
            return resolve(response.data)
          })
          .catch(error => {
            return reject(error.data)
          })
      }
    })
  }
}
